import { Coffee, Heart, Globe } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { useSiteContent } from "@/hooks/useSiteContent";

const Ministries = () => {
  const { t } = useLanguage();
  const { content } = useSiteContent('ministries');
  
  const ministries = [
    {
      icon: Coffee,
      title: t("ministries.women"),
      description: t("ministries.women.desc"),
      link: "/ministries/womens-ministry",
    },
    {
      icon: Heart,
      title: t("ministries.prayer"),
      description: t("ministries.prayer.desc"),
      link: "/ministries/prayer-ministry",
    },
    {
      icon: Globe,
      title: t("ministries.missions"),
      description: t("ministries.missions.desc"),
      link: "/missions",
    },
  ];

  return (
    <section id="ministries" className="py-20 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            {content.title || t("ministries.title")}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto whitespace-pre-line">
            {content.subtitle || t("ministries.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {ministries.map((ministry, index) => (
            <Link
              key={index}
              to={ministry.link}
              className="bg-background border border-border rounded-lg p-8 hover:shadow-lg transition-all hover:-translate-y-1 block"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6">
                <ministry.icon className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-2xl font-bold mb-3">{ministry.title}</h3>
              <p className="text-muted-foreground text-lg whitespace-pre-line">{ministry.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ministries;
